import {
  CompassOutlined,
  DollarOutlined,
  FileExcelOutlined,
  OpenAIOutlined,
  ProfileOutlined,
  SettingOutlined,
  YoutubeOutlined,
} from "@ant-design/icons";
import { ROUTES } from "@app/constants";
import PendingRequestsLabel from "@entities/manageRequests/ui/PendingRequestsLabel";
import { Invoice } from "@phosphor-icons/react";
import {
  FileTextOutlined,
  FolderFilled,
  ShareAltOutlined,
  TeamOutlined,
  UserOutlined
} from "@shared/ui/icons";
import { MenuProps } from "antd";
import { Calculator, PackageCheck, Sparkles, Wallet } from "lucide-react";

type MenuItem = Required<MenuProps>["items"][number];

export const menuItems: MenuItem[] = [
  {
    key: "brand",
    label: "Brand",
    type: "group",
    children: [
      {
        key: ROUTES.BRIEF,
        icon: <FileTextOutlined />,
        label: "Campaigns",
      },

      { key: ROUTES.BRAND, icon: <FileTextOutlined />, label: "Brand" },
      {
        key: ROUTES.ORGANISATION,
        icon: <FileTextOutlined />,
        label: "Organisation",
      },

      // {
      //   key: ROUTES.DISCOVERY_TRACKING,
      //   icon: <AimOutlined />,
      //   label: "Discovery Tracking",
      // },
      // {
      //   key: ROUTES.PRICING_TRACKING,
      //   icon: <AimOutlined />,
      //   label: "Pricing Tracking",
      // },

      { key: ROUTES.REPORTS, icon: <FileExcelOutlined />, label: "Reports" },
    ],
  },

  {
    key: "influencer",
    label: "Influencer",
    type: "group",
    children: [
      {
        key: ROUTES.GLOBAL_DISCOVERY,
        icon: <OpenAIOutlined />,
        label: "Discovery",
      },
      {
        key: ROUTES.AI_WORKSPACE,
        icon: <Sparkles size={18}/>,
        label: "AI Workspace",
      },
      {
        key: ROUTES.ADVANCED_YOUTUBE_SEARCH,
        icon: <YoutubeOutlined />,
        label: "Advanced YouTube Search",
      },
      { key: ROUTES.INFLUENCER, icon: <UserOutlined />, label: "Influencer" },
      {
        key: ROUTES.SOCIALMEDIA,
        icon: <ShareAltOutlined />,
        label: "Social Media",
      },

      { key: ROUTES.BUCKET, icon: <FolderFilled />, label: "Bucket" },

      {
        key: ROUTES.INFLUENCER_CAMPAIGN_REACHOUT,
        icon: <CompassOutlined />,
        label: "Campaign Reachout",
      },
      // {
      //   key: ROUTES.INFLUENCER_CONTACT_VERIFICATION,
      //   icon: <UserCheck />,
      //   label: "Contact Verification",
      // },
      {
        key: ROUTES.MY_PRICING,
        icon: <Calculator size={14} />,
        label: "My Pricing",
      },
      {
        key: ROUTES.CLOSURES,
        icon: <PackageCheck size={14} />,
        label: "My Closures",
      },
    ],
  },
  {
    key: "agency",
    label: "Agency",
    type: "group",
    children: [
      { key: ROUTES.Agency, icon: <TeamOutlined />, label: "Agency" },
      {
        key: ROUTES.REQUESTS,
        icon: <FileTextOutlined />,
        label: <PendingRequestsLabel text={"Requests"} />,
      },
      // {
      //   key: ROUTES.PERMISSIONS,
      //   icon: <SafetyOutlined />,
      //   label: "Permission",
      // },
    ],
  },

  {
    key: "finance",
    label: "Finance",
    type: "group",
    children: [
      {
        key: ROUTES.GST_INVOICES,
        icon: <Invoice />,
        label: "GST Invoices",
      },
      {
        key: ROUTES.FINANCE_APPROVAL_LOT,
        icon: <DollarOutlined />,
        label: "Finance Approval ",
      },
      {
        key: ROUTES.PAYOUTS,
        icon: <DollarOutlined />,
        label: "Payouts",
      },
      {
        key: ROUTES.BRAND_BILLING,
        icon: <ProfileOutlined />,
        label: "Brand Billing",
      },
      {
        key: ROUTES.ACCOUNTING,
        icon: <Wallet size={16} />,
        label: "Accounting",
      },
    ],
  },
  {
    key: "analytics",
    label: "Analytics",
    type: "group",
    children: [
      {
        key: ROUTES.PRICING_TRACKER,
        icon: <DollarOutlined />,
        label: "Pricing Tracker",
      },
    ],
  },
  {
    key: "admin",
    label: "Admin",
    type: "group",
    children: [
      { key: ROUTES.Admin, icon: <UserOutlined />, label: "Employee" },
      // {
      //   key: ROUTES.PERMISSIONS,
      //   icon: <SafetyOutlined />,
      //   label: "Permission Groups",
      // },
      {
        key: ROUTES.DELIVERABLE_CONFIGURATOR,
        icon: <SettingOutlined />,
        label: "Deliverable Configurator",
      },
    ],
  },
];
